<template>
    <div class="action--bar position--fixed display--flex background--green">
        <transition name="action--bar--transition" mode="out-in">
            <div v-if="loading" class="action--bar__loading">
                <span class="action--bar__loading__spinner"></span>
            </div>
            <span v-else class="action--bar__buttons">
                <base-button
                    class="action--bar__button action--bar__button--first background--transparent color--white"
                    @click="cancelSubmission"
                    v-html="$t('global.cancel')"
                />
                <base-button
                    form="newModel"
                    type="submit"
                    :class="[
                        'action--bar__button background--white color--green',
                        { 'disable': !$store.getters.payloadHaveKeys }
                    ]"
                    v-html="$t('global.submit')"
                />
            </span>
        </transition>
    </div>
</template>

<script>
// store
import { mapState, useActions } from '@/hooks/use-store';

export default {
    components: {
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    setup ( _, { emit, root: { $route, $router } }) {
        const loading = mapState({ module: 'storePayload', key: 'loading' });

        // submissão do formulário
        const { actions } = useActions();

        // o utilizador cancelou a submissão.
        // é fechado a barra de acção e dado clear
        // ao payload.
        const cancelSubmission = () => {
            emit( 'close-bar' );

            ( $route.meta.isAdd )
                ? $router.go( -1 ) // vai para a página anterior
                : actions( 'resetModel' );
        };

        return { loading, cancelSubmission };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    @include keyframes ( spin ) {
        0% {
            @include transform( rotate( 0deg ) );
        }
        100% {
            @include transform( rotate( 360deg ) );
        }
    }

    @include keyframes ( slide-in-down ) {
        0% {
            @include transform( translateY( -20px ) );
            opacity: 0;
        }
        50% {
            opacity: .8;
        }
        100% {
            @include transform( translateY( 0 ) );
            opacity: 1;
        }
    }

    @include keyframes ( slide-out-down ) {
        0% {
            @include transform( translateY( 0 ) );
            opacity: 1;
        }
        40% {
            opacity: .2;
        }
        100% {
            @include transform( translateY( 20px ) );
            opacity: 0;
        }
    }

    // =============================================================================
    // Style
    // =============================================================================
    .action {
        &--bar {
            @include transform-position( false, false, 0, 0 );
            align-items: center;
            justify-content: center;
            @include dimensions( 100%, 90px );
            z-index: 999;
            &--transition {
                &-leave-active {
                    @include animation( slide-out-down 260ms cubic-bezier( .4, .0, 1, 1 ) );
                }
                &-enter-active  {
                    @include animation( slide-in-down 260ms cubic-bezier( .0, .0, .2, 1 ) );
                }
            }
            &__loading {
                &__spinner {
                    display: inline-block;
                    vertical-align: middle;
                    @include dimensions( 1.5em, 1.5em );
                    border: .215em solid transparent;
                    border-top-color: $color-white;
                    @include rounded-corner( 50% );
                    margin: 0 8px;
                    @include animation( spin 1s cubic-bezier( .55, .15, .45, .85 ) infinite );
                }
            }
            &__buttons {
                width: 630px;
            }
            &__button {
                max-width: 300px;
                &--first {
                    margin-right: 30px;
                }
            }
        }
    }
</style>